<template lang="html">

  <section class="front-page">
    <v-content>
      <v-row class="mt-0 mb-n10 mb-md-0 mb-lg-0 mb-xl-0 pt-0 pb-0">
        <searchbar :type="'genre'" :cols="12" :sm="12" :md="12" :lg="12" :xl="12"></searchbar>
      </v-row>
      <GameList :headlines="recentlyPlayedByFriends" v-on:login="this.getRecentlyPlayedByFriends" :voteable="false"
                :showRating="true" :showUserRating="true"
                type="recently"
                :url="url" :user="user"></GameList>
      <GameList :headlines="recentlyPlayed" v-on:login="this.getRecentlyPlayed" :voteable="false" :showRating="true"
                type="popular" :showUserRating="false"
                :url="url" :user="user"></GameList>
      <GameList :headlines="popularThisMonth" v-on:login="this.getPopularThisMonth" :voteable="false"
                :showRating="true" :showUserRating="false"
                type="popular"
                :url="url" :user="user"></GameList>
      <GameList :headlines="popularThisYear" v-on:login="this.getPopularThisYear" :voteable="false" :showRating="true"
                type="popular" :showUserRating="false"
                :url="url" :user="user"></GameList>
    </v-content>

  </section>

</template>

<script lang="js">
import GameList from "./GameList";
import Searchbar from "./Searchbar";
import UserService from "../../services/UserService";

export default {
  name:       'front-page',
  props:      ['user'],
  components: {
    Searchbar,
    GameList
  },
  mounted () {
    this.url       = this.user ? window.api_url + '/api/auth/genres/games' : window.api_url + '/api/genres/games';
    this.recentUrl = window.api_url + '/api/auth/friends/recent';
    if (this.user) {
      this.getRecentlyPlayedByFriends();
    }
    this.getRecentlyPlayed();
    this.getPopularThisMonth();
    this.getPopularThisYear();
    this.getPublishers();
  },
  data () {
    return {
      'url':                     [],
      'recentUrl':               [],
      'rating':                  0,
      'recentlyPlayed':          [],
      'recentlyPlayedByFriends': [],
      'popularThisMonth':        [],
      'popularThisYear':         [],
    }
  },
  watch:    {
    user: {
      handler () {
        this.url = this.user ? window.api_url + '/api/auth/genres/games' : window.api_url + '/api/genres/games';
        if (this.user) {
          this.getRecentlyPlayedByFriends();
        }
        this.getRecentlyPlayed();
        this.getPopularThisMonth();
        this.getPopularThisYear();
      }
    },

  },
  methods:  {
    getRecentlyPlayedByFriends () {
      this.recentlyPlayedByFriends = [];
      UserService.getRecentlyPlayedByFriends(10)
                 .then(res => {
                   let headline        = res.data;
                   headline.name       = 'Recently played by friends';
                   headline.games      = {};
                   headline.games.data = headline.data;
                   this.recentlyPlayedByFriends.push(res.data);
                 })
    },
    getRecentlyPlayed () {
      //UserService.getRecentlyPlayed(10)
      //           .then(res => {
      //             let headline        = res.data;
      //             headline.name       = 'Recently played';
      //             headline.games      = {};
      //             headline.games.data = headline.data;
      //             this.recentlyPlayed = [];
      //             this.recentlyPlayed.push(res.data);
      //           })
      UserService.getPopular(7, 10)
                 .then(res => {
                   let headline        = res.data;
                   headline.name       = 'Popular this week';
                   headline.games      = {};
                   headline.games.data = headline.data;
                   this.recentlyPlayed = [];
                   this.recentlyPlayed.push(res.data);
                 })
    },
    getPopularThisMonth () {
      UserService.getPopular(30, 10)
                 .then(res => {
                   let headline        = res.data;
                   headline.name       = 'Popular this month';
                   headline.games      = {};
                   headline.games.data = headline.data;
                   this.popularThisMonth = [];
                   this.popularThisMonth.push(res.data);
                 })
    },
    getPopularThisYear () {
      UserService.getPopular(365, 10)
                 .then(res => {
                   let headline        = res.data;
                   headline.name       = 'Popular this year';
                   headline.games      = {};
                   headline.games.data = headline.data;
                   console.log(headline);
                   this.popularThisYear = [];
                   this.popularThisYear.push(res.data);
                 })
    },
  },
  computed: {},
}


</script>

<style lang="scss">
.front-page {

}

/** Remove Number Input Arrows */
input[type='number'] {
  -moz-appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button,
input[type='number']:hover::-webkit-inner-spin-button,
input[type='number']:hover::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>
